import { SxProps, Theme } from '@mui/material';
import React from 'react';

import { ServiceTitanAppointment, TimezoneAbbreviationEnum } from '_lib/api/apiTypes.shim';

import { MenuItem } from '_lib/components/MenuItem/MenuItem';
import { TextField } from '_lib/components/TextField/TextField';

import { FieldIssueProps } from '_lib/utils/validationErrorUtils';

import { AppointmentDisplay } from './AppointmentDisplay';

interface AppointmentSelectClearableProps extends FieldIssueProps {
  onSetServiceTitanAppointment: (serviceTitanAppointment: ServiceTitanAppointment | null) => void;
  serviceTitanAppointment: ServiceTitanAppointment | null;
  serviceTitanAppointments: ServiceTitanAppointment[];
  jobNo: string;
  timezone: TimezoneAbbreviationEnum;
  disabled?: boolean;
  required?: boolean;
  sx?: SxProps<Theme>;
}

export const AppointmentSelectClearable = (props: AppointmentSelectClearableProps) => {
  const {
    onSetServiceTitanAppointment,
    serviceTitanAppointment,
    serviceTitanAppointments,
    jobNo,
    disabled,
    required,
    timezone,
    issuePath,
    issues,
    sx
  } = props;

  return (
    <TextField
      fullWidth
      label='Appointment'
      required={required}
      disabled={disabled}
      value={serviceTitanAppointment?.providerId || ''}
      defaultValue={''}
      select
      error={{
        issues,
        issuePath
      }}
      sx={sx}
      onChange={(e) => {
        if (e.target.value) {
          const serviceTitanAppointment = serviceTitanAppointments.find((a) => a.providerId === e.target.value);
          onSetServiceTitanAppointment(serviceTitanAppointment || null);
        }
      }}>
      {serviceTitanAppointments.length > 0 && [
        <MenuItem key='empty' value='empty'>
          ---
        </MenuItem>,
        ...serviceTitanAppointments.map((serviceTitanAppointment) => {
          return (
            <MenuItem key={serviceTitanAppointment.providerId} value={serviceTitanAppointment.providerId}>
              <AppointmentDisplay serviceTitanAppointment={serviceTitanAppointment} jobNo={jobNo} timezone={timezone} />
            </MenuItem>
          );
        })
      ]}
      {serviceTitanAppointments.length === 0 && <MenuItem disabled>No Appointments found.</MenuItem>}
    </TextField>
  );
};
